export default "__VITE_ASSET__DQJRJhHY__"